import {
  opportunityStages,
  opportunityTypes,
  type OpportunityInsertSchema,
} from "@adva/types";
import {
  enumOptions,
  type EntityFieldConfig,
} from "@/components/v2/entity-form-config";

export type OpportunityFormValues = (typeof OpportunityInsertSchema)["_output"];

export function opportunityFields(
  customerOptions: { value: string; label: string }[],
): EntityFieldConfig<OpportunityFormValues>[] {
  return [
    { name: "name", label: "Name", control: "text" },
    {
      name: "stage",
      label: "Stage",
      control: "select",
      required: true,
      options: enumOptions(opportunityStages),
    },
    {
      name: "deal_type",
      label: "Opportunity type",
      control: "select",
      required: true,
      options: enumOptions(opportunityTypes),
    },
    {
      name: "customer_role_id",
      label: "Customer",
      control: "select",
      emptyOptionLabel: "Unassigned",
      options: customerOptions,
    },
    { name: "lead_source", label: "Lead source", control: "text" },
    { name: "notes", label: "Notes", control: "textarea" },
  ];
}

export function opportunityToFormValues(
  o: Record<string, unknown> | undefined,
): Partial<OpportunityFormValues> {
  if (!o) return {};
  const str = (v: unknown): string | undefined =>
    typeof v === "string" && v.length > 0 ? v : undefined;
  return {
    name: str(o.name),
    stage: (str(o.stage) as OpportunityFormValues["stage"]) ?? "lead",
    deal_type:
      (str(o.deal_type) as OpportunityFormValues["deal_type"]) ?? "project",
    customer_role_id: str(o.customer_role_id),
    lead_source: str(o.lead_source),
    notes: str(o.notes),
  };
}
